import styled from 'styled-components';

const StyledEntityInlineSearchContainer = styled.div`
  max-width: 400px;
`;

const StyledEntityInlineSearchResultsContainer = styled.div`
  max-height: 326px;
  overflow: auto;
`;

const StyledRequestItemContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
`;

export {
  StyledEntityInlineSearchContainer,
  StyledEntityInlineSearchResultsContainer,
  StyledRequestItemContent,
};
